/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doctorEvaluate } from 'Redux/modules/ai/actions';
import { RootState } from 'Redux/reducer';

const useDoctorEvaluate = () => {
  const dispatch = useDispatch();

  const aiStore = useSelector((state: RootState) => state.ai) as any;

  const { status } = aiStore;

  const isLoading = status?.doctorEvaluate === 0;

  const handleDoctorSendEvaluate = useCallback(
    (id: string, body: any) => {
      dispatch(doctorEvaluate(id, body));
    },
    [dispatch],
  );
  return {
    handleDoctorSendEvaluate,
    isLoading,
    isSuccess: status?.doctorEvaluate === 1,
  };
};

export default useDoctorEvaluate;
